import { useTranslation } from 'react-i18next';

const EmptyProductResults = () => {
  const [t] = useTranslation();

  return (
    <div className="d-flex flex-column align-items-center justify-content-center">
      <img
        src="https://caterpillar.scene7.com/is/image/Caterpillar/CM20220110-42177-9cddb"
        alt={'No parts'}
        height={'96px'}
        loading="lazy"
        className="d-lg-block"
      />
      <p className="text-center text-xl mb-5">{t('NO_MATCHING_PRODUCTS')}</p>
    </div>
  );
};

export default EmptyProductResults;
